import "./style/style2.css"

import Footer from './Footer';

import PhoneMockup from './images/Phone-Mockup.png';
import fleet1 from './images/fleet/iban.png';
import fleet2 from './images/fleet/commandes-map-duo.png';
import fleet3 from './images/fleet/mes-revenues.png';
import fleet4 from './images/fleet/congrats.png';
import UserPersonaDeliveryEN from './images/User-Persona-Delivery-EN.jpg';
import UserFlowInsFrAvn from './images/User-Flow-Fleet-Inscription-UI-Avant.jpg';
import UserFlowInsFrApr from './images/User-Flow-Fleet-Inscription-UI-Apres.jpg';
import RegistrationUIFr from './images/New-Fleet-UI-UX-Registeration.png';
import UserJourneyDeliveryEN from './images/User-Journey-Delivery-EN.jpg';
import UserFlowFullFR from './images/User-Flow-Plus-Complet-Delivery-FR.png';

import fleetMap from './images/fleet/map-view-ux-ui-webapp.png';
import bubblesDesign from './images/fleet/bubbles-ui-design-ux-iaxd.mp4';
import earningsScreen from './images/fleet/my-earnings-screen-ux-ui.mp4';
import deliveryFlow from './images/fleet/on-the-way-to-deliver-ux-ui.mp4';
import orderPickup from './images/fleet/order-pickup-ux-ui.mp4';
import fullFlow from './images/fleet/whole-flow.mp4';

import arrowIcon from './images/arrow.svg'

import folioFleet from './images/UX-UI-Project-Mobile-App-Fleet.png'

import { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';

import ScrollToTop from './ScrollToTop';
import ProjectNav from "./Project_Nav";

export default function ProjectFleet() {

  const [TransY, setTransY] = useState('translateY(333px)');
  const [OpacityB, setOpacityB] = useState('0.0');



  useEffect(() => {
    // This will be called after the initial render
    setOpacityB('1');
    setTransY('translateY(0px)');
  }, []);


  const onMouseClickHandler2 = async () => {

  }

  const ColoredLine = ({ color }) => (
    <hr
      style={{
        backgroundColor: color,
        height: 2
      }}
    />
  );

  return (
    <ScrollToTop>
      {/*<motion.div initial= {{y: 333, opacity:0}} animate= {{y: 0, opacity:1}} exit= {{opacity: 0}} transition = {{ duration: 1, ease: [0.22, 1, 0.36, 1]}}>*/}

      <div class="projectPage">
        {/* Navigation Arrows */}
        <div style={{ position: 'fixed', top: '13px', left: '13px', 'z-index': '55', opacity: OpacityB }}>
          <div style={{ position: 'absolute', transform: 'rotate(-134deg)' }}>
            <Link to="/" style={{ 'text-decoration': 'none' }}>
              <div class='iconCircle'><img src={arrowIcon} style={{ margin: '0px', transform: 'translate(-2px,-3px)' }} /></div>
            </Link>
          </div>
        </div>
        <div style={{ position: 'fixed', bottom: '67px', right: '67px', 'z-index': '55', opacity: OpacityB }}>
          <div style={{ position: 'absolute', transform: 'rotate(-45deg)' }}>
            <a href="#top" style={{ cursor: 'default' }}>
              <div class='iconCircle'><img src={arrowIcon} style={{ margin: '0px', transform: 'translate(-1px,-2px)' }} /></div>
            </a>
          </div>
        </div>

        <div className="bar" style={{ 'background-color': '#532dfa', opacity: OpacityB }}>
          <img src={folioFleet} style={{ opacity: OpacityB, transform: "translateY(37px)" }} />
        </div>
        <div className="bar2" style={{ 'background-color': '#532dfa', transform: TransY, opacity: OpacityB, position: 'sticky', top: 0 }}>
          <div class="projectHeader">
            <div class="textBoxLeft">
              <div class="smallText">Client:</div>
              <div class="projectTitle">Dishop<br /></div>
            </div>
            <div class="projectTitleRight">
              <div class="smallText">Summary</div>
              <div class="projectTitle">Designed the User Experience and Interface of the app 'Fleet' to optimize delivery workflows and minimize friction for drivers on the go.</div>
            </div>
          </div>

          <div class="projectHeader">
            <div class="textBoxLeft">
              <div class="smallText">Role:</div>
              <div class="projectTitle">UX Design<br />UI Design</div>
            </div>
            <div class="projectTitleRight">
              <div class="smallText">Tools</div>
              <div class="projectTitle">Figma, Miro, Adobe Photoshop</div>
            </div>
          </div>
        </div>

        <div class="Rido" style={{ top: '0px', 'background-color': '#ffffff', opacity: '1', 'z-index': '-2' }}></div>

        <div class="ProjectContainer" style={{ transform: TransY, opacity: OpacityB }}>
          <div class="section">
            <div class="oneColumnIntro">
              <h2>Introduction</h2>
              <div class="IntroTexts">Fleet is a mobile app that enables restaurant franchises to deliver orders through an intelligent, self-dispatching system by connecting them with independent delivery person.</div>
            </div>
          </div>

          <div class="sectionDarker">
            <div class="sectionColumn"></div>
            <div class="sectionColumn">
              <div class="title"><h2>Problem Statement</h2></div>
              <p>How might we design a new version of Fleet that is <strong>intuitive</strong> and efficient, allowing restaurant delivery person to <strong>sign up without friction</strong>, locate nearby orders, and <strong>optimize delivery routes</strong>, all while reducing the time and effort needed for these actions ?</p>
            </div>
          </div>

          <div class="insidePictures">
            <div class="phoneMock"><img src={PhoneMockup} alt="Phone-Mockup" /><div class="phoneScree"><img src={fleet1} /></div></div>
            <div class="phoneMock"><img src={PhoneMockup} alt="Phone-Mockup" /><div class="phoneScree"><img src={fleet2} /></div></div>
            <div class="phoneMock"><img src={PhoneMockup} alt="Phone-Mockup" /><div class="phoneScree"><img src={fleet3} /></div></div>
            <div class="phoneMock"><img src={PhoneMockup} alt="Phone-Mockup" /><div class="phoneScree"><img src={fleet4} /></div></div>
          </div>

          <div class="section">
            <div class="objectifsColumn">
              <h2>Project Goals</h2>
            </div>
            <div class="objectifsColumn">
              <div class="point"><div class="number">1</div><div>Make the app more intuitive</div></div>
              <div class="point"><div class="number">2</div><div>Improve route optimization system</div></div>
              <div class="point"><div class="number">3</div><div>Reduce friction between registration and order acceptance</div></div>
              <div class="point"><div class="number">4</div><div>Increase delivery person retention rate</div></div>
              <div class="point"><div class="number">5</div><div>Provide more contextual information on the map view</div></div>
            </div>
          </div>

          <div class="GrayBG">

            <div class="smallTitle">A New Version of Fleet</div>
            <div class="bigTitle">On the map,<br /> at a glance,<br /> and at your fingertips</div>


            <div class="commentSection">
              <div class="commentColumnScreen">

                <img style={{ width: '273px', padding: '33px', borderRadius: '83px' }} src={fleetMap} />

              </div>
              <div class="commentColumn">
                <h3>Home Screen: 'The Map'</h3>
                <p>After signing up, the delivery person lands on a map that provides everything needed to start delivering.</p>
                <ul>
                  <li>View nearby restaurants and available orders</li>
                  <li>Estimate distance between current location and restaurants</li>
                  <li>Choose orders based on distance and efficiency</li>
                  <li>Optimize routes to handle multiple deliveries at once</li>
                </ul>
              </div>
            </div>

            <div class="commentSection">
              <div class="commentColumn">
                <h3>More Space for the Map</h3>
                <p>The map, being the most frequently used feature by delivery person, was prioritized to take up more screen space.</p>
                <ul>
                  <li>Floating bubble UI replaces bulky rectangular boxes</li>
                  <li>'GO' button is removed to maximize fullscreen map view</li>
                  <li>Navigation bar replaced with a dropdown accessible via profile icon</li>
                </ul>
              </div>
              <div class="commentColumnScreen"><div class="phone-video"><video controls="true" autoplay="true" loop="true" muted width="100%" style={{ borderRadius: '47px' }}  src={bubblesDesign} type="video/mp4" /></div></div>
            </div>

            <div class="commentSection">
              <div class="commentColumnScreen"><div class="phone-video"><video controls="true" autoplay="true" loop="true" muted width="100%" style={{ borderRadius: '47px' }}  src={orderPickup} type="video/mp4" /></div></div>
              <div class="commentColumn">
                <h3>Order Pickup</h3>
                <p>Different delivery person have different preferences:</p>
                <ul>
                  <li>Two ways to view pending orders</li>
                  <li>Option to view all orders from nearby restaurants</li>
                  <li>Ability to pick up 1 to 3 orders from the same restaurant simultaneously</li>
                </ul>
                <div class="speech-bubble"><p><i>Orders are sorted by proximity to the delivery person’s current location</i></p></div>
              </div>
            </div>

            <div class="commentSection">
              <div class="commentColumn">
                <h3>On the Way to Deliver</h3>
                <p>After accepting orders, delivery person see the <strong>delivery routes</strong> directly on the map, each marked with a number.</p>
                <p>Since delivery person prioritize <strong>saving time</strong>, we introduced a <strong>"press-and-hold"</strong> interaction on route numbers.</p>
                <p>This brings up a quick info window showing <strong>key delivery details</strong> like the delivery address, which remains visible as long as the press is held, and disappears upon release.</p>
              </div>
              <div class="commentColumnScreen"><div class="phone-video"><video controls="true" autoplay="true" loop="true" muted width="100%" style={{ borderRadius: '47px' }} src={deliveryFlow} type="video/mp4" /></div></div>
            </div>
            <div class="commentSection">

              <div class="commentColumnScreen"><div class="phone-video"><video controls="true" autoplay="true" loop="true" muted width="100%" style={{ borderRadius: '47px' }} src={earningsScreen} type="video/mp4" /></div> </div>
              <div class="commentColumn">
                <h3>'My Earnings' Screen</h3>
                <p>
                  Seeing real-time earnings increases delivery person motivation and encourages continued activity. The ability to visualize earnings over time (weekly, monthly, yearly) helps users track performance and identify trends.
                </p>
                <p>
                  <ul>
                    <li>Visual insights to quickly identify high-performing periods.</li>
                    <li>Tabs for week, month, or year — no need to scroll through endless transaction lists.</li>
                    <li>Option to view additional details by clicking on individual transactions.</li>
                  </ul>
                </p>

              </div>
            </div>

          </div>

          {//Recherche processess
          }
          <div class="smallTitle">A Smooth Signup</div>
          <div class="bigTitle">Ready to Deliver <br />in Seconds</div>
          <div class="section">
            <div class="sectionColumn"></div>
            <div class="sectionColumn">
              <div class="title"><h2>Sign-up Pain Point</h2></div>
              <p>
                During interviews, one major friction point identified was related to mandatory information during sign-up.
                New delivery person without a SIRET registration number <strong>had to wait up to 2 weeks</strong> to receive one before being able to start delivering.
              </p>
              <p>This waiting period often led to a <strong>loss of interest in the platform</strong>.</p>
            </div>
          </div>


          <div class="section">

            <div class="oneColumn">
              <div class="title"><h2>Updated User Flow</h2></div>
              <p>
                To address this, I proposed removing the document verification block and allowing the delivery person to <strong>start delivering and earning</strong> while waiting for their SIRET number.
              </p>

              <div class="insideSection">
                <div class="commentColumn">
                  <div class="medTitle">Before</div>
                  <img src={UserFlowInsFrAvn} alt="User-Flow-Ins-Fr-avant" />
                </div>
                <div class="commentColumn">
                  <div class="medTitle">After</div>
                  <img src={UserFlowInsFrApr} alt="User-Flow-Ins-Fr-Apres" />
                </div>
              </div>


              <br />


              <div class="title"><h2>A Lighter UI</h2></div>
              <p>
                In the previous version of Fleet, users had to navigate to their "Profile" to input independent worker status information.
              </p>
              <p>
                In the new version, this step is integrated directly into the onboarding flow. Users input <strong>one field at a time</strong> to avoid cognitive overload and can see from the beginning that there are only <strong>three steps</strong> in total, making the process smoother and more manageable.
              </p>
              <p>
                Delivery persons can also <strong id='onBoarding'>skip this step</strong> and complete it later by selecting "Finish Later."
              </p>
              <img src={RegistrationUIFr} alt="RegistrationUIFr" />



            </div>
          </div>

          <div class="GrayBG">


            <div class="smallTitle">The Prototype</div>
            <div class="bigTitle">From Signup to First Earnings</div>
            <div class="commentColumnScreen">
              <div class="phone-video"><video controls="true" autoplay="true" loop="true" muted width="100%" style={{ borderRadius: '47px' }} src={fullFlow} type="video/mp4" /></div> </div>
          </div>


          <div class="smallTitle">Research Process</div>
          <div class="bigTitle">Delivery persons Want Speed and Profit</div>

          <div class="section">
            <div class="sectionColumn">
            </div>
            <div class="sectionColumn">
              <div class="title"><h2>User Interviews</h2></div>
              <p>
                I conducted interviews to gather insights on the user experience of both the Fleet and Uber Eats (delivery person) mobile apps, focusing on delivery management expectations and workflows.
              </p>
              <p>
                I wanted to understand <strong>how delivery person complete a delivery mission</strong> from start to finish, and what tools and features they <strong>need</strong> to succeed.
              </p>
              <p>
                By discussing app efficiency and delivery person experiences, I identified both strengths and <strong>pain points in the existing Fleet app.</strong>
              </p>
              <p>
                These findings enabled me to design a solution tailored to the real needs and behaviors of Fleet users.
              </p>
            </div>
          </div>


          <div class="sectionDarker">
            <div class="oneColumn">
              <div class="title"><h2>Conceptualization</h2></div>
              <p>
                Based on interview insights, I created a <strong>user persona</strong> that reflects the typical Fleet delivery person — including their goals, background, and frustrations.
              </p>
              <img src={UserPersonaDeliveryEN} alt="UserPersonaDeliveryEN" />

              <br /><br /><br />
              <div class="title"><h2>User Journey</h2></div>
              <p>
                To empathize and deeply understand the user experience, I mapped out the delivery person’s journey across four key phases.
              </p>
              <img src={UserJourneyDeliveryEN} alt="UserJourneyDeliveryEN" />
              <p>
                Analyzing this journey revealed <strong>two key opportunities</strong> to improve the overall user experience, as outlined in the map.
              </p>

              <h3>Opportunity 1</h3>
              <p>
                Delivery persons experience frustration if documents are not immediately accepted, potentially <strong>delaying their start.</strong>
              </p>
              <p>
                To address this, I proposed removing the verification bottleneck and enabling delivery person to use the app, begin deliveries, and earn income while documents are processed — helping to <strong>retain them as users.</strong>
              </p>
              <p>
                The only concern was whether it is <strong>legally allowed in France</strong> to begin working before having a SIRET number.
              </p>
              <p>
                It turns out that <strong>delivery person can start</strong> their activity while awaiting the SIRET, provided they’ve initiated the auto-entrepreneur registration process.
              </p>
              <p>
                After brainstorming with the dev team, we implemented a smoother onboarding using a <strong>three-step breadcrumb model</strong> (<a href="#onBoarding">see sign-up UI above</a>).
              </p>

              <h3>Opportunity 2</h3>
              <p>
                Our typical user wants to complete deliveries quickly to satisfy customers and move on to the next order efficiently.
              </p>
              <p>
                This represents another opportunity to enhance the current UX and introduce new features that help delivery person <strong>complete tasks more quickly.</strong>
              </p>

              <br />
              <div class="title"><h2>User Flow</h2></div>
              <p>This is the user flow for a returning delivery person.</p>
              <img src={UserFlowFullFR} alt="UserFlowFullFR" />

              <p>
                That wraps up the presentation! Contextual research and user interviews were essential in identifying opportunities and shaping the ideation phase. The result is a streamlined, intuitive app experience that empowers freelance delivery person while supporting restaurant partners.
              </p>
              <p>Thank you for your attention.</p>
            </div>
          </div>

          <ProjectNav NextProject='/projects-multiple' PrevProject='/project-dishop' />

          <Footer />
        </div>

      </div>




    </ScrollToTop>
  )

}
